import React from "react";
import Svg, { Path, Circle } from "react-native-svg";

const GrayCross = (props) => {
  return (
    <Svg
      width={props.width || "24"}
      height={props.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Circle
        cx="12"
        cy="12"
        r="12"
        fill="rgba(0, 0, 0, 0.3)"
        fill-opacity="0.3"
      />
      <Path
        d="M13.0994 12L17.772 7.32726C18.076 7.02332 18.076 6.5319 17.772 6.22796C17.468 5.92401 16.9766 5.92401 16.6726 6.22796L11.9999 10.9007L7.32737 6.22796C7.02329 5.92401 6.532 5.92401 6.22806 6.22796C5.92398 6.5319 5.92398 7.02332 6.22806 7.32726L10.9006 12L6.22806 16.6727C5.92398 16.9766 5.92398 17.468 6.22806 17.772C6.37953 17.9236 6.5787 17.9998 6.77772 17.9998C6.97674 17.9998 7.17576 17.9236 7.32737 17.772L11.9999 13.0993L16.6726 17.772C16.8243 17.9236 17.0233 17.9998 17.2223 17.9998C17.4213 17.9998 17.6203 17.9236 17.772 17.772C18.076 17.468 18.076 16.9766 17.772 16.6727L13.0994 12Z"
        fill="white"
      />
    </Svg>
  );
};

export default GrayCross;
